module.exports = __webpack_public_path__ + "img/perfil.d2e90ef4.png";